import { defineMessages } from "react-intl";
import {
  DASHBOARD_FILTER_CRITERIA,
  DASHBOARD_FILTER_CRITERIA_DATE,
} from "../witadmin/Common/constants";

export const dashboardMessages = {
  ...defineMessages({
    [DASHBOARD_FILTER_CRITERIA_DATE.LAST_N_DAYS]: {
      id: "dashboard.chart.filter.lastNDays",
      defaultMessage: "Last {day} days",
    },
    [DASHBOARD_FILTER_CRITERIA_DATE.CUSTOM_DATE]: {
      id: "dashboard.chart.filter.customDays",
      defaultMessage: "Custom Date",
    },
    [DASHBOARD_FILTER_CRITERIA.BY_BOOKING_DATE]: {
      id: "dashboard.chart.filter.byBookingDate",
      defaultMessage: "Reservation No. by reservation date",
    },
    [DASHBOARD_FILTER_CRITERIA.BY_BOOKING_CHECKOUT_DATE]: {
      id: "dashboard.chart.filter.byBookingDateOut",
      defaultMessage: "Reservation No. by departure date",
    },
    [DASHBOARD_FILTER_CRITERIA.BY_CHECKIN_DATE]: {
      id: "dashboard.chart.filter.byCheckInDate",
      defaultMessage: "Amount of reservations by departure date",
    },
    [DASHBOARD_FILTER_CRITERIA.BY_CHECKOUT_DATE]: {
      id: "dashboard.chart.filter.byCheckOutDate",
      defaultMessage: "Amount of reservations by reservation date",
    },
  }),
};

export const chartMessages = {
  ...defineMessages({
    chartTitle: {
      id: "dashboard.chart.title",
      defaultMessage: "Reservations",
    },
    currentPeriod: {
      id: "dashboard.chart.currentPeriod",
      defaultMessage: "Current period",
    },
    lastYear: {
      id: "dashboard.chart.lastYear",
      defaultMessage: "Last year",
    },
    annotationBooking: {
      id: "dashboard.chart.annotationBooking",
      defaultMessage: "Cancellations are not excluded",
    },
    annotationCheckout: {
      id: "dashboard.chart.annotationCheckout",
      defaultMessage: "Cancellations are excluded. For future date queries, the gray line shows the 'on the books' on the same date last year.",
    },
  }),
};
export const listDataMessages = {
  ...defineMessages({
    listDatatitle: {
      id: "dashboard.listReservations.title",
      defaultMessage: "List of reservations",
    },
    viewAllList: {
      id: "dashboard.listReservations.viewAllList",
      defaultMessage: "View all list",
    },
    fieldID: {
      id: "dashboard.listReservations.fieldID",
      defaultMessage: "ID Multiple",
    },
    fieldCheckIn: {
      id: "dashboard.listReservations.fieldCheckIn",
      defaultMessage: "Check in",
    },
    fieldCheckOut: {
      id: "dashboard.listReservations.fieldCheckOut",
      defaultMessage: "Check out",
    },
    fieldName: {
      id: "dashboard.listReservations.fieldName",
      defaultMessage: "Name",
    },
    fieldStatus: {
      id: "dashboard.listReservations.fieldStatus",
      defaultMessage: "Status",
    },
    fieldAmount: {
      id: "dashboard.listReservations.fieldAmount",
      defaultMessage: "u",
    },
  }),
};

export const modalMessages = {
  ...defineMessages({
    available: {
      id: "dashboard.calendar.available",
      defaultMessage: "Available",
    },
    notAvailable: {
      id: "dashboard.calendar.notAvailable",
      defaultMessage: "Not available",
    },
    allowedDays: {
      id: "dashboard.calendar.allowedDays",
      defaultMessage: "Solo podran seleccionar maximo 31 dias",
    },
    search: {
      id: "dashboard.calendar.search",
      defaultMessage: "Buscar",
    },
    recentSearches: {
      id: "dashboard.calendar.recentSearches",
      defaultMessage: "Búsquedas recientes",
    },
    noRecords: {
      id: "dashboard.calendar.noRecords",
      defaultMessage: "Sin registros",
    },
    title: {
      id: "dashboard.calendar.title",
      defaultMessage: "Fecha Personalizada",
    },
    back: {
      id: "dashboard.calendar.back",
      defaultMessage: "Volver",
    },
    ranking: {
      id: "dashboard.calendar.ranking",
      defaultMessage: "Ranking",
    },
    lastMonth: {
      id: "dashboard.calendar.lastMonth",
      defaultMessage: "Last Month",
    },
    fromCalendar: {
      id: "dashboard.calendar.from",
      defaultMessage: "From",
    },
    toCalendar: {
      id: "dashboard.calendar.to",
      defaultMessage: "To",
    },
  }),
};

export const motorMessages: any = {
  ...defineMessages({
    myEngine: {
      id: "dashboard.myEngine",
      defaultMessage: "My booking engine",
    },
    lastDays: {
      id: "dashboard.LastDays",
      defaultMessage: "(Last 7 days)",
    },
    bestSellingProduct: {
      id: "dashboard.bestSellingProduct",
      defaultMessage: "best Selling Product",
    },
    bestSellingProductDescription: {
      id: "dashboard.bestSellingProductDescription",
      defaultMessage: "best Selling Product Description",
    },
    bestSellingPromotionalCode: {
      id: "dashboard.bestSellingPromotionalCode",
      defaultMessage: "best Selling Promotional Code",
    },
    bestSellingPromotionalCodeDescription: {
      id: "dashboard.bestSellingPromotionalCodeDescription",
      defaultMessage: "best Selling Promotional Code Description",
    },
    bestSellingMealPlan: {
      id: "dashboard.bestSellingMealPlan",
      defaultMessage: "best Selling Meal Plan",
    },
    bestSellingMealPlanDescription: {
      id: "dashboard.bestSellingMealPlanDescription",
      defaultMessage: "best Selling Meal Plan Description",
    },
    bestSellingDiscount: {
      id: "dashboard.bestSellingDiscount",
      defaultMessage: "best Selling Discount",
    },
    bestSellingDiscountDescription: {
      id: "dashboard.bestSellingDiscountDescription",
      defaultMessage: "best Selling Discount Description",
    },
    bestSellingDiscountList: {
      id: "dashboard.bestSellingDiscountList",
      defaultMessage: "best Selling Discount List",
    },
    bestSellingDiscountListDescription: {
      id: "dashboard.bestSellingDiscountListDescription",
      defaultMessage: "best Selling Discount List Description",
    },
    nextUnavailableDate: {
      id: "dashboard.nextUnavailableDate",
      defaultMessage: "Next date without availability",
    },
    nextUnavailableDateDescription: {
      id: "dashboard.nextUnavailableDateDescription",
      defaultMessage: "Next date without availability",
    },
    seeDetails: {
      id: "dashboard.myMotor.seeDetails",
      defaultMessage: "See details",
    },
  }),
};

export const notificationsMessages = {
  ...defineMessages({
    notificationsTitle: {
      id: "dashboard.notifications.title",
      defaultMessage: "My Engine",
    },
  }),
};

export const bookingStatMessages: any = {
  ...defineMessages({
    sales: {
      id: "dashboard.cards.sales",
      defaultMessage: "Sales (Yesterday)",
    },
    cancellations: {
      id: "dashboard.cards.cancellations",
      defaultMessage: "Cancellations (Yesterday)",
    },
    averageStay: {
      id: "dashboard.cards.averageStay",
      defaultMessage: "Average Stay (Yesterday - days)",
    },
    reserveHorizont: {
      id: "dashboard.cards.reserveHorizont",
      defaultMessage: "Reserve Horizont",
    },
    months: {
      id: "dashboard.cards.months",
      defaultMessage: "months",
    },
    tooltipGeneral: {
      id: "dashboard.cards.tooltipGeneral",
      defaultMessage: "Compared to the same date last year",
    },
    tooltipReserveHorizont: {
      id: "dashboard.cards.tooltipReserveHorizont",
      defaultMessage: "Last date with uploaded availability",
    },
  }),
};
